(function () {
  if (window.__nariyalCartAddDedupe) {
    return;
  }

  window.__nariyalCartAddDedupe = true;

  var originalFetch = window.fetch ? window.fetch.bind(window) : null;
  var recentAdds = new Map();
  var duplicateWindowMs = 1200;

  if (!originalFetch) {
    return;
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') {
      return input;
    }

    if (input && input.url) {
      return input.url;
    }

    return '';
  }

  function isCartAddUrl(rawUrl) {
    if (!rawUrl) {
      return false;
    }

    try {
      var url = new URL(rawUrl, window.location.origin);
      return /\/cart\/add(\.js)?$/.test(url.pathname);
    } catch (error) {
      return rawUrl.indexOf('/cart/add') !== -1;
    }
  }

  function normalizeItemsFromParams(params) {
    var items = [];

    if (params.has('id')) {
      items.push({
        id: params.get('id'),
        quantity: params.get('quantity') || '1'
      });
    }

    for (var index = 0; params.has('items[' + index + '][id]'); index++) {
      items.push({
        id: params.get('items[' + index + '][id]'),
        quantity: params.get('items[' + index + '][quantity]') || '1'
      });
    }

    return items.length ? items.map(function (item) {
      return item.id + ':' + item.quantity;
    }).join('|') : '';
  }

  function normalizeItemsFromJson(payload) {
    if (!payload || typeof payload !== 'object') {
      return '';
    }

    if (Array.isArray(payload.items)) {
      return payload.items.map(function (item) {
        return item.id + ':' + (item.quantity || 1);
      }).join('|');
    }

    if (payload.id) {
      return payload.id + ':' + (payload.quantity || 1);
    }

    return '';
  }

  function getCartAddSignature(init) {
    var body = init && init.body;

    if (!body) {
      return '';
    }

    if (body instanceof FormData) {
      return normalizeItemsFromParams(body);
    }

    if (body instanceof URLSearchParams) {
      return normalizeItemsFromParams(body);
    }

    if (typeof body === 'string') {
      try {
        return normalizeItemsFromJson(JSON.parse(body));
      } catch (error) {
        return normalizeItemsFromParams(new URLSearchParams(body));
      }
    }

    return '';
  }

  window.fetch = function (input, init) {
    var rawUrl = getRequestUrl(input);

    if (!isCartAddUrl(rawUrl)) {
      return originalFetch(input, init);
    }

    var signature = getCartAddSignature(init);

    if (!signature) {
      return originalFetch(input, init);
    }

    var now = Date.now();
    var previous = recentAdds.get(signature);

    if (previous && now - previous.at < duplicateWindowMs) {
      return previous.promise.then(function (response) {
        return response.clone();
      });
    }

    var requestPromise = originalFetch(input, init);
    recentAdds.set(signature, {
      at: now,
      promise: requestPromise
    });

    requestPromise.finally(function () {
      window.setTimeout(function () {
        var latest = recentAdds.get(signature);

        if (latest && latest.promise === requestPromise) {
          recentAdds.delete(signature);
        }
      }, duplicateWindowMs);
    });

    return requestPromise;
  };
})();

/* Keep the order-level Free Gift after every paid and promotional product. */
(function () {
  if (window.__nariyalFreeGiftLast) return;
  window.__nariyalFreeGiftLast = true;

  var scheduled = false;

  function reorderFreeGift() {
    scheduled = false;
    document.querySelectorAll('.line-item--free-gift').forEach(function (gift) {
      var parent = gift.parentElement;
      if (!parent) return;

      var products = Array.prototype.filter.call(parent.children, function (child) {
        return child.classList &&
          child.classList.contains('line-item') &&
          !child.classList.contains('line-item--free-gift');
      });
      if (!products.length) return;

      var lastProduct = products[products.length - 1];
      if (lastProduct.nextElementSibling !== gift) {
        parent.insertBefore(gift, lastProduct.nextSibling);
      }
    });
  }

  function scheduleReorder() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(reorderFreeGift);
  }

  document.addEventListener('DOMContentLoaded', scheduleReorder);
  document.documentElement.addEventListener('cart:refresh', scheduleReorder);
  document.documentElement.addEventListener('cart:updated', scheduleReorder);
  new MutationObserver(scheduleReorder).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  scheduleReorder();
})();

/*
 * Cart-page recommendations can be clicked faster than Shopify's product-form
 * redirect completes. Queue those requests and reload only after every click
 * has reached the server, so no recommendation item is lost.
 */
(function () {
  if (window.__nariyalCartRecommendationQueue) return;
  window.__nariyalCartRecommendationQueue = true;

  var addQueue = Promise.resolve();
  var queuedAdds = 0;
  var reloadTimer = null;

  function cartAddUrl() {
    var routes = window.themeVariables && window.themeVariables.routes;
    return (routes ? routes.cartAddUrl : '/cart/add') + '.js';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || !form.closest('.shopify-section--cart-recommendations')) return;
    if (String(form.action || '').indexOf('/cart/add') === -1) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.clearTimeout(reloadTimer);

    var formData = new FormData(form);
    var button = form.querySelector('[type="submit"]');
    queuedAdds += 1;

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    addQueue = addQueue
      .then(function () {
        return window.fetch(cartAddUrl(), {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-Nariyal-Featured-Collection-Add': '1'
          }
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (payload) {
            throw new Error(payload.description || 'Unable to add product');
          });
        }

        return response.json();
      })
      .catch(function (error) {
        console.error('[Cart recommendation add]', error);
        window.alert(error.message || 'Product could not be added. Please try again.');
      })
      .finally(function () {
        queuedAdds -= 1;

        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }

        if (queuedAdds === 0) {
          reloadTimer = window.setTimeout(function () {
            window.location.reload();
          }, 450);
        }
      });
  }, true);
})();

/*
 * Notify Me injects the product wishlist action after Add to Bag. Keep the
 * customer-facing order consistent on every PDP: Add to Bag, Buy It Now,
 * then Add to wishlist. The app button itself is moved so its click handler
 * and wishlist state remain untouched.
 */
(function () {
  if (window.__nariyalWishlistBelowBuyNow) {
    return;
  }

  window.__nariyalWishlistBelowBuyNow = true;
  var openNotifyFromCard = new URLSearchParams(window.location.search).get('notify_me') === '1';

  function placeWishlistBelowBuyNow() {
    document.querySelectorAll('.nm-wishlist-button').forEach(function (wishlistButton) {
      var tlpcButtons = wishlistButton.closest('.product-tlpc__buttons');

      if (tlpcButtons) {
        var tlpcCheckout = tlpcButtons.querySelector('.product-tlpc__dynamic-checkout');

        if (tlpcCheckout && tlpcCheckout.nextElementSibling !== wishlistButton) {
          tlpcCheckout.insertAdjacentElement('afterend', wishlistButton);
        }

        return;
      }

      var paymentContainer = wishlistButton.closest('.product-form__payment-container');

      if (!paymentContainer) {
        return;
      }

      var buyNowButton = paymentContainer.querySelector(
        '[data-nariyal-buy-now], .shopify-payment-button__button'
      );

      if (buyNowButton && buyNowButton.nextElementSibling !== wishlistButton) {
        buyNowButton.insertAdjacentElement('afterend', wishlistButton);
      }
    });
  }

  function placeNotifyMeLast() {
    document.querySelectorAll('[class*="notify-button"]:not([class*="float-button"])').forEach(function (notifyButton) {
      var tlpcButtons = notifyButton.closest('.product-tlpc__buttons');

      if (tlpcButtons) {
        var tlpcAnchor = tlpcButtons.querySelector('.nm-wishlist-button') ||
          tlpcButtons.querySelector('.product-tlpc__dynamic-checkout') ||
          tlpcButtons.querySelector('.product-tlpc__btn-atc');

        if (tlpcAnchor && tlpcAnchor.nextElementSibling !== notifyButton) {
          tlpcAnchor.insertAdjacentElement('afterend', notifyButton);
        }

        if (openNotifyFromCard && !window.__nariyalNotifyAutoOpened) {
          var tlpcNotifyTrigger = notifyButton.matches('button') ? notifyButton : notifyButton.querySelector('button');

          if (tlpcNotifyTrigger) {
            window.__nariyalNotifyAutoOpened = true;
            tlpcNotifyTrigger.click();

            var tlpcCleanUrl = new URL(window.location.href);
            tlpcCleanUrl.searchParams.delete('notify_me');
            window.history.replaceState({}, '', tlpcCleanUrl.pathname + tlpcCleanUrl.search + tlpcCleanUrl.hash);
          }
        }

        return;
      }

      var paymentContainer = notifyButton.closest('.product-form__payment-container');

      if (!paymentContainer) {
        return;
      }

      var standardAnchor = paymentContainer.querySelector('.nm-wishlist-button') ||
        paymentContainer.querySelector(
          '[data-nariyal-buy-now], .shopify-payment-button__button'
        ) ||
        paymentContainer.querySelector('[data-product-add-to-cart-button]');

      if (standardAnchor && standardAnchor.nextElementSibling !== notifyButton) {
        standardAnchor.insertAdjacentElement('afterend', notifyButton);
      }

      if (openNotifyFromCard && !window.__nariyalNotifyAutoOpened) {
        var notifyTrigger = notifyButton.matches('button') ? notifyButton : notifyButton.querySelector('button');

        if (notifyTrigger) {
          window.__nariyalNotifyAutoOpened = true;
          notifyTrigger.click();

          var cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('notify_me');
          window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
        }
      }
    });
  }

  function renameWishlistCartButton() {
    document.querySelectorAll('.nm-wishlist-item-add-to-cart-button').forEach(function (button) {
      if (button.textContent.trim() !== 'Add to Bag') {
        button.textContent = 'Add to Bag';
        button.setAttribute('aria-label', 'Add to Bag');
      }
    });
  }

  function hideWishlistActions() {
    document.querySelectorAll(
      '.nariyal-header-wishlist, .nm-wishlist-button, .nm-wishlist-open-list-button, .nm-wishlist-inline-access-button'
    ).forEach(function (wishlistAction) {
      wishlistAction.style.setProperty('display', 'none', 'important');
    });

    document.querySelectorAll('button, a').forEach(function (action) {
      var label = (action.getAttribute('aria-label') || action.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (label === 'wishlist' || label === 'add to wishlist') {
        action.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function placeProductActions() {
    hideWishlistActions();
    placeNotifyMeLast();
    renameWishlistCartButton();
  }

  var wishlistPlacementObserver = new MutationObserver(placeProductActions);
  wishlistPlacementObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', placeProductActions);
  document.addEventListener('shopify:section:load', placeProductActions);

  document.addEventListener('click', function (event) {
    var headerWishlist = event.target.closest('.nariyal-header-wishlist');

    if (!headerWishlist) {
      return;
    }

    event.preventDefault();

    var appWishlistAccess = document.querySelector(
      '.nm-wishlist-open-list-button, .nm-wishlist-inline-access-button'
    );

    if (appWishlistAccess) {
      appWishlistAccess.click();
    }
  });
})();

/*
 * Native theme cart integration.
 * Open the theme mini cart after any successful customer-initiated AJAX add.
 * The automatic free-gift request uses the previously captured native fetch,
 * so it does not trigger the cart a second time.
 */
(function () {
  if (window.__nariyalNativeCartTrigger || !window.fetch) {
    return;
  }

  window.__nariyalNativeCartTrigger = true;

  var nativeCartFetch = window.fetch.bind(window);
  var triggerTimer = null;

  function isCartAdd(input, init) {
    var rawUrl = typeof input === 'string' ? input : input && input.url;
    var headers = init && init.headers;
    var isAutomaticGift = false;
    var isDeferredFeaturedCollectionAdd = false;

    if (headers && typeof headers.get === 'function') {
      isAutomaticGift = headers.get('X-Nariyal-Automatic-Gift') === '1';
      isDeferredFeaturedCollectionAdd =
        headers.get('X-Nariyal-Featured-Collection-Add') === '1';
    } else if (headers) {
      isAutomaticGift =
        headers['X-Nariyal-Automatic-Gift'] === '1' ||
        headers['x-nariyal-automatic-gift'] === '1';
      isDeferredFeaturedCollectionAdd =
        headers['X-Nariyal-Featured-Collection-Add'] === '1' ||
        headers['x-nariyal-featured-collection-add'] === '1';
    }

    return (
      !isAutomaticGift &&
      !isDeferredFeaturedCollectionAdd &&
      rawUrl &&
      /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(rawUrl)
    );
  }

  function triggerNativeCart() {
    nativeCartFetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, openMiniCart: true }
      }));
    }).catch(function (error) {
      console.error('[Nariyal native cart trigger]', error);
    });
  }

  function scheduleNativeCart() {
    window.clearTimeout(triggerTimer);

    /*
     * Allow the purchased line and complimentary gift to finish syncing
     * before the theme reads and opens the cart.
     */
    triggerTimer = window.setTimeout(function () {
      triggerNativeCart();
    }, 450);
  }

  // The free-gift guard defined later owns the timing. Expose the opener so
  // it can launch the native mini cart after the server cart is normalized.
  window.__nariyalScheduleNativeCart = scheduleNativeCart;

  window.fetch = function (input, init) {
    var responsePromise = nativeCartFetch(input, init);

    if (!isCartAdd(input, init)) {
      return responsePromise;
    }

    return responsePromise;
  };
})();

/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
  */
document.addEventListener('cart:update', function (event) {
  if (event.detail && event.detail.data && event.detail.data.source === 'cart-drawer-bridge') return;

  Promise.all([
    fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); }),
    fetch(window.Shopify.routes.root + 'cart?sections=mini-cart').then(function (response) { return response.json(); })
  ]).then(function (results) {
    var cart = results[0];
    cart.sections = results[1];

    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        cart: cart,
        openMiniCart: false
      }
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
      bubbles: true,
      detail: { status: 'success' }
    }));
  });
});

/*
 * Rapi represents the soap Buy 3 Get 3 offer as two cart lines with the same
 * variant (one paid and one complimentary). Removing only the paid key leaves
 * the complimentary key behind, which makes the promotion restore the pair.
 * Update both linked keys atomically whenever the customer changes the paid
 * quantity. A paid quantity of 2 therefore keeps 2 complimentary units, while
 * zero removes the complete offer. Other products continue through the
 * theme's standard cart handler.
 */
(function () {
  if (window.__nariyalSoapOfferPairRemoval) {
    return;
  }

  window.__nariyalSoapOfferPairRemoval = true;
  var linkedOfferVariantIds = {
    '55264654229809': true,
    '55026179309873': true
  };
  var cartControlInProgress = false;

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
    return root + path;
  }

  function refreshTheme(cart) {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        cart: cart,
        replacementDelay: 0,
        openMiniCart: true
      }
    }));
  }

  function xhrJson(method, url, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.setRequestHeader('Accept', 'application/json');

      if (body !== undefined) {
        xhr.setRequestHeader('Content-Type', 'application/json');
      }

      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 400) {
          reject(new Error('Cart request failed with status ' + xhr.status));
          return;
        }

        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = function () {
        reject(new Error('Cart request failed'));
      };
      xhr.send(body === undefined ? null : JSON.stringify(body));
    });
  }

  /* VCO Remove clears its paid/free pair and the order-level free gift. */
  document.addEventListener('click', function (event) {
    var removeLink = event.target.closest('.line-item__remove-button');
    var vcoRow = removeLink && removeLink.closest(
      'line-item[data-variant-id="55026179309873"], tr.line-item[data-variant-id="55026179309873"]'
    );
    if (!removeLink || !vcoRow || vcoRow.classList.contains('line-item--vco-bogo-free') || window.__nariyalVcoRemovalPending) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.__nariyalVcoRemovalPending = true;
    cartControlInProgress = true;
    vcoRow.style.pointerEvents = 'none';
    vcoRow.style.opacity = '.55';

    xhrJson('GET', cartUrl('cart.js')).then(function (cart) {
      var updates = {};
      cart.items.forEach(function (item) {
        var variantId = String(item.variant_id);
        if (variantId === '55026179309873' || variantId === '51610279444785') {
          updates[item.key] = 0;
        }
      });
      return xhrJson('POST', cartUrl('cart/update.js'), { updates: updates });
    }).then(function () {
      window.location.reload();
    }).catch(function (error) {
      console.error('[Nariyal VCO remove]', error);
      window.__nariyalVcoRemovalPending = false;
      cartControlInProgress = false;
      vcoRow.style.pointerEvents = '';
      vcoRow.style.opacity = '';
    });
  }, true);

  /* Soap Pack Remove must clear every paid/free promotion line together. */
  document.addEventListener('click', function (event) {
    var removeLink = event.target.closest('.line-item__remove-button');
    var soapRow = removeLink && removeLink.closest(
      'line-item[data-variant-id="55264654229809"], tr.line-item[data-variant-id="55264654229809"]'
    );
    if (!removeLink || !soapRow || window.__nariyalSoapRemovalPending) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.__nariyalSoapRemovalPending = true;
    cartControlInProgress = true;
    soapRow.style.pointerEvents = 'none';
    soapRow.style.opacity = '.55';

    xhrJson('GET', cartUrl('cart.js')).then(function (cart) {
      var updates = {};
      cart.items.forEach(function (item) {
        if (String(item.variant_id) === '55264654229809' || item.sku === 'NARI6SOAP') {
          updates[item.key] = 0;
        }
      });
      return xhrJson('POST', cartUrl('cart/update.js'), { updates: updates });
    }).then(function () {
      window.location.reload();
    }).catch(function (error) {
      console.error('[Nariyal Soap remove]', error);
      window.__nariyalSoapRemovalPending = false;
      cartControlInProgress = false;
      soapRow.style.pointerEvents = '';
      soapRow.style.opacity = '';
    });
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      '#mini-cart line-item .line-item__remove-button,' +
      '#mini-cart line-item .quantity-selector__button,' +
      '.shopify-section--main-cart tr.line-item:not(.line-item--soap-offer-free) .line-item__remove-button,' +
      '.shopify-section--main-cart tr.line-item:not(.line-item--soap-offer-free) .quantity-selector__button'
    );

    if (!link || cartControlInProgress) {
      return;
    }

    var row = link.closest('line-item, tr.line-item');
    var isMiniCart = Boolean(link.closest('#mini-cart'));
    var linkedVariantId = row && row.getAttribute('data-variant-id');
    var isLinkedOffer = Boolean(linkedVariantId && linkedOfferVariantIds[linkedVariantId]);

    var linkUrl = new URL(link.href, window.location.origin);
    var desiredQuantity = parseInt(linkUrl.searchParams.get('quantity'), 10);
    if (!Number.isFinite(desiredQuantity) || desiredQuantity < 0) {
      return;
    }

    /*
     * Normal full-cart controls can use Shopify's native navigation, except
     * Remove. The last paid product and every complimentary cart line must be
     * cleared atomically so the customer never lands on a gift-only cart.
     */
    if (!row || (!isMiniCart && !isLinkedOffer && desiredQuantity !== 0)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    cartControlInProgress = true;
    row.style.pointerEvents = 'none';
    row.style.opacity = '.55';

    if (desiredQuantity === 0) {
      var activeCart = isMiniCart
        ? document.querySelector('#mini-cart')
        : link.closest('.shopify-section--main-cart');
      var visiblePaidRows = Array.from(activeCart.querySelectorAll(
        isMiniCart ? 'line-item' : 'tr.line-item'
      )).filter(function (cartRow) {
        return cartRow.querySelector('.line-item__remove-button') &&
          !cartRow.classList.contains('line-item--free-gift') &&
          !cartRow.classList.contains('line-item--soap-offer-free') &&
          !cartRow.classList.contains('line-item--vco-bogo-free');
      });

      if (visiblePaidRows.length === 1 && visiblePaidRows[0] === row) {
        activeCart.querySelectorAll('.line-item--free-gift').forEach(function (giftRow) {
          giftRow.remove();
        });
      }
    }

    var request;

    if (desiredQuantity === 0) {
      request = xhrJson('GET', cartUrl('cart.js')).then(function (cart) {
        var line = parseInt(linkUrl.searchParams.get('line'), 10);
        var id = linkUrl.searchParams.get('id');
        var targetItem = id
          ? cart.items.find(function (item) {
              return item.key === id || String(item.variant_id) === id;
            })
          : cart.items[line - 1];

        if (!targetItem && !isLinkedOffer) {
          throw new Error('Unable to find cart line to remove');
        }

        var remainingPaidItems = cart.items.filter(function (item) {
          return (
            (!targetItem || item.key !== targetItem.key) &&
            (!isLinkedOffer || String(item.variant_id) !== linkedVariantId) &&
            String(item.variant_id) !== '51610279444785' &&
            item.final_line_price > 0
          );
        });
        var updates = {};

        if (remainingPaidItems.length === 0) {
          cart.items.forEach(function (item) {
            updates[item.key] = 0;
          });
        } else if (isLinkedOffer) {
          cart.items.forEach(function (item) {
            if (String(item.variant_id) === linkedVariantId) {
              updates[item.key] = 0;
            }
          });
        } else {
          updates[targetItem.key] = 0;
        }

        return xhrJson('POST', cartUrl('cart/update.js'), { updates: updates });
      });
    } else if (isLinkedOffer) {
      request = xhrJson('GET', cartUrl('cart.js')).then(function (cart) {
        var updates = {};
        var paidLineKept = false;
        var freeLineFound = false;

        cart.items.forEach(function (item) {
          if (String(item.variant_id) !== linkedVariantId) return;

          var itemRole = item.properties && (
            item.properties._vco_bogo_role || item.properties._soap_bogo_role
          );
          var isFreeOfferLine = itemRole === 'free' || (!itemRole && item.final_line_price === 0);

          if (isFreeOfferLine) {
            updates[item.key] = desiredQuantity;
            freeLineFound = true;
            return;
          }

          updates[item.key] = paidLineKept ? 0 : desiredQuantity;
          paidLineKept = true;
        });

        return xhrJson('POST', cartUrl('cart/update.js'), { updates: updates }).then(function (updatedCart) {
          if (freeLineFound) return updatedCart;

          return xhrJson('POST', cartUrl('cart/add.js'), {
            items: [{
              id: Number(linkedVariantId),
              quantity: desiredQuantity,
              properties: linkedVariantId === '55026179309873'
                ? { _vco_bogo_role: 'free' }
                : { _soap_bogo_role: 'free' }
            }]
          }).then(function () {
            return xhrJson('GET', cartUrl('cart.js'));
          });
        });
      });
    } else {
      var changePayload = {
        quantity: desiredQuantity,
        sections: ['mini-cart']
      };
      var line = linkUrl.searchParams.get('line');
      var id = linkUrl.searchParams.get('id');

      if (id) {
        changePayload.id = id;
      } else {
        changePayload.line = parseInt(line, 10);
      }

      request = xhrJson('POST', cartUrl('cart/change.js'), changePayload);
    }

    request
      .then(refreshTheme)
      .catch(function (error) {
        console.error('[Nariyal cart controls]', error);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .finally(function () {
        cartControlInProgress = false;
      });
  }, true);
})();

/*
 * Branded add-to-cart toast.
 * Shows a small bouncing confirmation for AJAX add-to-cart actions across the storefront.
 */
(function () {
  if (window.__nariyalAddToCartToast) {
    return;
  }

  window.__nariyalAddToCartToast = true;

  var originalFetch = window.fetch ? window.fetch.bind(window) : null;
  var lastSubmittedProduct = null;
  var toastTimer = null;
  var toastHideTimer = null;

  if (!originalFetch) {
    return;
  }

  function isCartAddUrl(input) {
    var rawUrl = typeof input === 'string' ? input : input && input.url;

    if (!rawUrl) {
      return false;
    }

    try {
      var url = new URL(rawUrl, window.location.origin);
      return /\/cart\/add(\.js)?$/.test(url.pathname);
    } catch (error) {
      return rawUrl.indexOf('/cart/add') !== -1;
    }
  }

  function cleanImageUrl(url) {
    if (!url) {
      return '';
    }

    if (url.indexOf('//') === 0) {
      return window.location.protocol + url;
    }

    return url;
  }

  function getProductFromResponse(payload) {
    var item = payload && Array.isArray(payload.items) ? payload.items[0] : payload;

    if (!item || typeof item !== 'object') {
      return {};
    }

    return {
      title: item.product_title || item.title || item.name || '',
      image: cleanImageUrl(item.featured_image && item.featured_image.url ? item.featured_image.url : item.image)
    };
  }

  function getProductFromForm(form) {
    if (!form || !form.closest) {
      return {};
    }

    var scope = form.closest('.product-item, .product, .shopify-section, section') || document;
    var titleEl = scope.querySelector('.product-meta__title, .product-item-meta__title, .product-title, [data-product-title], h1, h2, h3');
    var imageEl = scope.querySelector('.product__media img, .product-gallery img, .product-item__primary-image, .product-item img, img');

    return {
      title: titleEl ? titleEl.textContent.trim() : '',
      image: imageEl ? cleanImageUrl(imageEl.currentSrc || imageEl.src) : ''
    };
  }

  function ensureToast() {
    var toast = document.querySelector('[data-nariyal-cart-toast]');

    if (toast) {
      return toast;
    }

    toast = document.createElement('div');
    toast.className = 'nariyal-cart-toast';
    toast.setAttribute('data-nariyal-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('tabindex', '0');
    toast.innerHTML = [
      '<div class="nariyal-cart-toast__accent" aria-hidden="true"></div>',
      '<img class="nariyal-cart-toast__image" data-toast-image alt="">',
      '<div class="nariyal-cart-toast__content">',
      '  <div class="nariyal-cart-toast__message">Added to cart!</div>',
      '  <div class="nariyal-cart-toast__title" data-toast-title></div>',
      '</div>',
      '<button type="button" class="nariyal-cart-toast__close" data-toast-close aria-label="Close notification">&times;</button>'
    ].join('');
    document.body.appendChild(toast);

    toast.querySelector('[data-toast-close]').addEventListener('click', function () {
      hideToast(toast);
    });

    toast.addEventListener('click', function (event) {
      if (event.target.closest('[data-toast-close]')) {
        return;
      }

      window.location.href = window.themeVariables && window.themeVariables.routes ? window.themeVariables.routes.cartUrl : '/cart';
    });

    toast.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        window.location.href = window.themeVariables && window.themeVariables.routes ? window.themeVariables.routes.cartUrl : '/cart';
      }
    });

    return toast;
  }

  function hideToast(toast) {
    clearTimeout(toastTimer);
    clearTimeout(toastHideTimer);
    toast.classList.remove('is-visible');
    toastHideTimer = window.setTimeout(function () {
      toast.hidden = true;
    }, 260);
  }

  function showToast(product) {
    if (window.__nariyalSuppressCartToastUntil && Date.now() < window.__nariyalSuppressCartToastUntil) {
      return;
    }

    var toast = ensureToast();
    var title = product && product.title ? product.title : 'Product';
    var image = product && product.image ? product.image : '';
    var imageEl = toast.querySelector('[data-toast-image]');

    toast.querySelector('[data-toast-title]').textContent = title;

    if (image) {
      imageEl.src = image;
      imageEl.alt = title;
      imageEl.hidden = false;
    } else {
      imageEl.removeAttribute('src');
      imageEl.alt = '';
      imageEl.hidden = true;
    }

    clearTimeout(toastTimer);
    clearTimeout(toastHideTimer);
    toast.hidden = false;
    toast.classList.remove('is-visible');

    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    toastTimer = window.setTimeout(function () {
      hideToast(toast);
    }, 2800);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form && form.matches && form.matches('form[action*="/cart/add"], form[is="product-form"], [data-type="add-to-cart-form"]')) {
      lastSubmittedProduct = getProductFromForm(form);
    }
  }, true);

  document.addEventListener('nariyal:cart-added', function (event) {
    showToast(getProductFromResponse(event.detail && event.detail.item ? event.detail.item : {}));
  });

  window.fetch = function (input, init) {
    var requestPromise = originalFetch(input, init);

    if (!isCartAddUrl(input)) {
      return requestPromise;
    }

    requestPromise.then(function (response) {
      if (!response || !response.ok) {
        return;
      }

      response.clone().json().then(function (payload) {
        var responseProduct = getProductFromResponse(payload);
        showToast({
          title: responseProduct.title || (lastSubmittedProduct && lastSubmittedProduct.title) || 'Product',
          image: responseProduct.image || (lastSubmittedProduct && lastSubmittedProduct.image) || ''
        });
      }).catch(function () {
        showToast(lastSubmittedProduct || {});
      });
    });

    return requestPromise;
  };
})();

/*
 * Never attach combo contents to products that are sold as standalone items.
 * Some third-party bundle forms can leak their Included products field into a
 * later cart request. Sanitize every AJAX payload for these known single SKUs.
 */
(function () {
  if (window.__nariyalStandaloneCartPropertyGuard || !window.fetch) {
    return;
  }

  window.__nariyalStandaloneCartPropertyGuard = true;

  var standaloneVariantIds = {
    '55026163908913': true // Virgin Coconut Oil Cold Pressed 100 ml
  };
  var soapBuy3Get3VariantId = '55264654229809';
  var vcoBuyOneGetOneVariantId = '55026179309873';
  var soapBuy3Get3Property = '{"main":true,"id":"k3t1","offer":"AEWYX"}';
  var sunscreenBuy1Get1VariantId = '52465434722609';
  var sunscreenBuy1Get1Property = '{"main":true,"id":"125913","offer":"YbJla"}';
  var lipBalmVariantId = '55025194631473';
  var lipBalmBuyMoreProperty = '{"main":true,"id":"157393","offer":"JmWJG"}';
  var guardedFetch = window.fetch.bind(window);

  function isCartAddRequest(input) {
    var rawUrl = typeof input === 'string' ? input : input && input.url;
    return rawUrl && rawUrl.indexOf('/cart/add') !== -1;
  }

  function selectedRapiOfferValue() {
    var input = document.querySelector('[name="properties[__rapi_offer]"]');
    return input && input.value ? input.value : '';
  }

  function isLipBalmBuyMoreOffer(value) {
    return String(value || '').indexOf('JmWJG') !== -1;
  }

  function soapOfferCartQuantity(value) {
    var requestedQuantity = parseInt(value, 10);
    return Number.isFinite(requestedQuantity) && requestedQuantity > 0
      ? requestedQuantity
      : 1;
  }

  function sanitizeParams(params) {
    var variantId = params.get('id');

    params.delete('properties[Free gift]');

    if (String(variantId) === soapBuy3Get3VariantId) {
      params.set('properties[__rapi_offer]', soapBuy3Get3Property);
      /* Keep the charged cart quantity unchanged. The complimentary pack is
         represented by the dedicated cart display row. */
      params.set('quantity', String(soapOfferCartQuantity(params.get('quantity'))));
    }

    if (String(variantId) === sunscreenBuy1Get1VariantId) {
      params.set('properties[__rapi_offer]', sunscreenBuy1Get1Property);
      params.set('properties[_rapi_bundles]', '125913');
    }

    if (String(variantId) === lipBalmVariantId) {
      var lipBalmOffer = params.get('properties[__rapi_offer]') || selectedRapiOfferValue();
      if (isLipBalmBuyMoreOffer(lipBalmOffer)) {
        params.set('properties[__rapi_offer]', lipBalmBuyMoreProperty);
        params.set('properties[_rapi_bundles]', '157393');
        params.set('quantity', '2');
      }
    }

    for (var index = 0; params.has('items[' + index + '][id]'); index++) {
      params.delete('items[' + index + '][properties][Free gift]');

      if (String(params.get('items[' + index + '][id]')) === soapBuy3Get3VariantId) {
        params.set('items[' + index + '][properties][__rapi_offer]', soapBuy3Get3Property);
        params.set(
          'items[' + index + '][quantity]',
          String(soapOfferCartQuantity(params.get('items[' + index + '][quantity]')))
        );
      }
      if (String(params.get('items[' + index + '][id]')) === sunscreenBuy1Get1VariantId) {
        params.set('items[' + index + '][properties][__rapi_offer]', sunscreenBuy1Get1Property);
        params.set('items[' + index + '][properties][_rapi_bundles]', '125913');
      }
      if (String(params.get('items[' + index + '][id]')) === lipBalmVariantId) {
        var indexedLipBalmOffer = params.get('items[' + index + '][properties][__rapi_offer]') || selectedRapiOfferValue();
        if (isLipBalmBuyMoreOffer(indexedLipBalmOffer)) {
          params.set('items[' + index + '][properties][__rapi_offer]', lipBalmBuyMoreProperty);
          params.set('items[' + index + '][properties][_rapi_bundles]', '157393');
          params.set('items[' + index + '][quantity]', '2');
        }
      }
    }

    if (standaloneVariantIds[String(variantId)]) {
      params.delete('properties[Included products]');
    }
  }

  function sanitizeJson(payload) {
    if (!payload || typeof payload !== 'object') {
      return payload;
    }

    var items = Array.isArray(payload.items) ? payload.items : [payload];

    items.forEach(function (item) {
      if (item && item.properties) {
        delete item.properties['Free gift'];

        if (Object.keys(item.properties).length === 0) {
          delete item.properties;
        }
      }

      if (item && String(item.id) === soapBuy3Get3VariantId) {
        item.properties = item.properties || {};
        item.properties.__rapi_offer = soapBuy3Get3Property;
        item.quantity = soapOfferCartQuantity(item.quantity);
      }

      if (item && String(item.id) === sunscreenBuy1Get1VariantId) {
        item.properties = item.properties || {};
        item.properties.__rapi_offer = sunscreenBuy1Get1Property;
        item.properties._rapi_bundles = '125913';
      }

      if (item && String(item.id) === lipBalmVariantId) {
        var jsonLipBalmOffer = item.properties && item.properties.__rapi_offer
          ? item.properties.__rapi_offer
          : selectedRapiOfferValue();
        if (isLipBalmBuyMoreOffer(jsonLipBalmOffer)) {
          item.properties = item.properties || {};
          item.properties.__rapi_offer = lipBalmBuyMoreProperty;
          item.properties._rapi_bundles = '157393';
          item.quantity = 2;
        }
      }

      if (!item || !standaloneVariantIds[String(item.id)] || !item.properties) {
        return;
      }

      delete item.properties['Included products'];

      if (Object.keys(item.properties).length === 0) {
        delete item.properties;
      }
    });

    return payload;
  }

  function requestedVcoCompanionQuantity(body) {
    var paidQuantity = 0;
    var hasFreeLine = false;

    function inspectItem(id, quantity, role) {
      if (String(id) !== vcoBuyOneGetOneVariantId) return;
      if (String(role || '') === 'free') {
        hasFreeLine = true;
        return;
      }
      paidQuantity += Math.max(1, parseInt(quantity, 10) || 1);
    }

    if (body instanceof FormData || body instanceof URLSearchParams) {
      if (body.has('id')) {
        inspectItem(body.get('id'), body.get('quantity'), body.get('properties[_vco_bogo_role]'));
      }

      for (var index = 0; body.has('items[' + index + '][id]'); index++) {
        inspectItem(
          body.get('items[' + index + '][id]'),
          body.get('items[' + index + '][quantity]'),
          body.get('items[' + index + '][properties][_vco_bogo_role]')
        );
      }
    } else if (typeof body === 'string') {
      try {
        var payload = JSON.parse(body);
        var items = Array.isArray(payload.items) ? payload.items : [payload];
        items.forEach(function (item) {
          inspectItem(
            item && item.id,
            item && item.quantity,
            item && item.properties && item.properties._vco_bogo_role
          );
        });
      } catch (error) {
        return requestedVcoCompanionQuantity(new URLSearchParams(body));
      }
    }

    return hasFreeLine ? 0 : paidQuantity;
  }

  function addVcoCompanion(quantity) {
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.__nariyalVcoCompanionRequest = true;
      request.open('POST', (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', true);
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('Content-Type', 'application/json');
      request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      request.onload = function () {
        if (request.status < 200 || request.status >= 400) {
          reject(new Error('Unable to add the complimentary VCO bottle'));
          return;
        }
        resolve();
      };
      request.onerror = function () {
        reject(new Error('Unable to add the complimentary VCO bottle'));
      };
      request.send(JSON.stringify({
        items: [{
          id: Number(vcoBuyOneGetOneVariantId),
          quantity: quantity,
          properties: { _vco_bogo_role: 'free' }
        }]
      }));
    });
  }

  window.fetch = function (input, init) {
    if (!isCartAddRequest(input) || !init || !init.body) {
      return guardedFetch(input, init);
    }

    var vcoCompanionQuantity = requestedVcoCompanionQuantity(init.body);

    if (init.body instanceof FormData || init.body instanceof URLSearchParams) {
      sanitizeParams(init.body);
    } else if (typeof init.body === 'string') {
      try {
        init.body = JSON.stringify(sanitizeJson(JSON.parse(init.body)));
      } catch (error) {
        var params = new URLSearchParams(init.body);
        sanitizeParams(params);
        init.body = params.toString();
      }
    }

    return guardedFetch(input, init).then(function (response) {
      if (!response.ok || !vcoCompanionQuantity) return response;

      return addVcoCompanion(vcoCompanionQuantity).then(function () {
        return response;
      });
    });
  };

  if (window.XMLHttpRequest && !window.__nariyalVcoXhrPairGuard) {
    window.__nariyalVcoXhrPairGuard = true;

    var originalXhrOpen = XMLHttpRequest.prototype.open;
    var originalXhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__nariyalVcoCartAdd =
        !this.__nariyalVcoCompanionRequest &&
        String(method || 'GET').toUpperCase() === 'POST' &&
        String(url || '').indexOf('/cart/add') !== -1;

      return originalXhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      var request = this;
      var companionQuantity = request.__nariyalVcoCartAdd
        ? requestedVcoCompanionQuantity(body)
        : 0;

      if (!companionQuantity) {
        return originalXhrSend.call(request, body);
      }

      addVcoCompanion(companionQuantity)
        .catch(function (error) {
          console.error('[Nariyal VCO companion]', error);
        })
        .then(function () {
          originalXhrSend.call(request, body);
        });
    };
  }
})();

/*
 * Cart drawer policy: adding an item only shows the confirmation toast.
 * The drawer may open exclusively from an intentional cart-icon click.
 */
(function () {
  if (window.__nariyalCartDrawerPolicy) {
    return;
  }

  window.__nariyalCartDrawerPolicy = true;

  var suppressDrawerUntil = 0;
  var policyFetch = window.fetch ? window.fetch.bind(window) : null;
  var observer = null;

  function isCartAddUrl(input) {
    var rawUrl = typeof input === 'string' ? input : input && input.url;
    return rawUrl && rawUrl.indexOf('/cart/add') !== -1;
  }

  function closeDrawer() {
    var drawer = document.getElementById('mini-cart');

    if (!drawer || Date.now() >= suppressDrawerUntil) {
      return;
    }

    if ('open' in drawer) {
      drawer.open = false;
    }

    drawer.removeAttribute('open');
  }

  function suppressDrawer() {
    suppressDrawerUntil = Date.now() + 2500;
    closeDrawer();
    window.setTimeout(closeDrawer, 0);
    window.setTimeout(closeDrawer, 100);
    window.setTimeout(closeDrawer, 350);
    window.setTimeout(closeDrawer, 800);
  }

  function watchDrawer() {
    var drawer = document.getElementById('mini-cart');

    if (!drawer || observer) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'open' && drawer.hasAttribute('open')) {
          closeDrawer();
        }
      });
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  document.addEventListener('DOMContentLoaded', watchDrawer);
  watchDrawer();

  document.addEventListener('click', function (event) {
    var cartTrigger = event.target.closest('[aria-controls="mini-cart"], a[href="/cart"], a[href$="/cart"]');

    if (cartTrigger) {
      suppressDrawerUntil = 0;
      return;
    }

    var addButton = event.target.closest('button[type="submit"], input[type="submit"], .product-tlpc__btn-buy-now, .sticky-atc-tlpc__btn');
    var addForm = addButton && addButton.form;

    if ((addForm && String(addForm.action).indexOf('/cart/add') !== -1) ||
        (addButton && addButton.matches('.product-tlpc__btn-buy-now, .sticky-atc-tlpc__btn'))) {
      suppressDrawer();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form && String(form.action || '').indexOf('/cart/add') !== -1) {
      suppressDrawer();
    }
  }, true);

  document.addEventListener('variant:added', suppressDrawer, true);
  document.addEventListener('nariyal:cart-added', suppressDrawer, true);

  if (policyFetch) {
    window.fetch = function (input, init) {
      return policyFetch(input, init);
    };
  }
})();

/*
 * Keep mobile menu footer login usable with Shopify's account modal.
 * The menu drawer is closed after the account trigger receives the click so the modal content stays visible.
 */
(function () {
  if (window.__nariyalAccountDrawerFix) {
    return;
  }

  window.__nariyalAccountDrawerFix = true;

  document.addEventListener('click', function (event) {
    var accountTrigger = event.target.closest('#mobile-menu-drawer shopify-account, .drawer--menu shopify-account');

    if (!accountTrigger) {
      return;
    }

    window.setTimeout(function () {
      var drawer = document.querySelector('#mobile-menu-drawer, .drawer--menu[open]');

      if (!drawer) {
        return;
      }

      if ('open' in drawer) {
        drawer.open = false;
      } else {
        drawer.removeAttribute('open');
      }
    }, 80);
  }, true);
})();

/*
 * Keep Shopify product videos/GIF-like uploaded media playing automatically.
 * Muted + playsinline videos are allowed to autoplay by modern mobile browsers,
 * but sliders/drawers can insert or reveal them after the first page load.
 */
(function () {
  function playAutoplayMedia(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video[autoplay], video.js-autoplay-media').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
      video.play().catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    playAutoplayMedia(document);
    window.setTimeout(function () { playAutoplayMedia(document); }, 500);
    window.setTimeout(function () { playAutoplayMedia(document); }, 1500);
  });

  document.addEventListener('shopify:section:load', function (event) {
    playAutoplayMedia(event.target);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) playAutoplayMedia(document);
  });

  document.addEventListener('click', function () {
    playAutoplayMedia(document);
  }, { once: true });
})();

/*
 * One complimentary gift per cart.
 * The gift is a real ₹0 product so it remains visible in checkout,
 * Shopify Admin orders and packing workflows.
 */
(function () {
  /* Disabled: adding a paid product must not create a second cart line. */
  // return;

  if (window.__nariyalAutomaticFreeGift || !window.fetch) {
    return;
  }

  window.__nariyalAutomaticFreeGift = true;

  var giftVariantId = 51610279444785;
  var giftVariantIdString = String(giftVariantId);
  var giftFetch = window.fetch.bind(window);
  var syncPromise = null;
  var syncNotBefore = 0;
  var stabilizationTimers = [];
  var buyNowIntentUntil = 0;
  var checkoutGiftGuardBusy = false;
  var checkoutGiftGuardBypass = false;

  /*
   * Promotion apps can perform one final cart write while checkout is
   * opening. Gate both checkout buttons behind a server-cart verification so
   * an order can never be created with two complimentary gift units.
   */
  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest(
      '.cart__checkout-button, #mini-cart .checkout-button'
    );

    if (!checkoutButton || checkoutGiftGuardBypass) {
      checkoutGiftGuardBypass = false;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (checkoutGiftGuardBusy) {
      return;
    }

    checkoutGiftGuardBusy = true;
    checkoutButton.setAttribute('aria-busy', 'true');
    checkoutButton.disabled = true;
    var checkoutCanProceed = false;

    ensureGiftReady()
      .then(function (cart) {
        var giftLines = cart.items.filter(isComplimentaryGiftLine);
        var regularItems = cart.items.filter(function (item) {
          return !isComplimentaryGiftLine(item) && item.final_line_price > 0;
        });

        if (
          regularItems.length === 0 ||
          giftLines.length !== 1 ||
          giftLines[0].quantity !== 1
        ) {
          throw new Error('Checkout blocked: no paid product with one verified gift');
        }

        checkoutCanProceed = true;
      })
      .catch(function (error) {
        console.error('[Nariyal checkout gift guard]', error);

        if (/No paid product|no paid product/i.test(error && error.message)) {
          window.alert('Checkout ke liye pehle ek product cart mein add karein.');
        } else {
          window.alert('Cart verify nahi ho paya. Please ek baar phir try karein.');
        }
      })
      .finally(function () {
        checkoutGiftGuardBusy = false;
        checkoutButton.removeAttribute('aria-busy');
        checkoutButton.disabled = false;

        if (!checkoutCanProceed) {
          return;
        }
      });
  }, true);

  document.addEventListener('click', function (event) {
    var buyNowButton = event.target.closest(
      '[data-nariyal-buy-now]'
    );

    if (buyNowButton) {
      buyNowIntentUntil = Date.now() + 5000;
    }
  }, true);

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    return root + path;
  }

  function isComplimentaryGiftLine(item) {
    if (!item) return false;

    var properties = item.properties || {};
    var title = String(item.product_title || item.title || '').trim();

    return (
      String(item.variant_id) === giftVariantIdString ||
      Object.prototype.hasOwnProperty.call(properties, '_free-gift') ||
      (item.final_line_price === 0 && /^free gift$/i.test(title))
    );
  }

  function isCartMutation(input) {
    var rawUrl = typeof input === 'string' ? input : input && input.url;

    return Boolean(
      rawUrl &&
      /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(rawUrl)
    );
  }

  function isCartAdd(input) {
    var rawUrl = typeof input === 'string' ? input : input && input.url;

    return Boolean(
      rawUrl &&
      /\/cart\/add(?:\.js)?(?:\?|$)/.test(rawUrl)
    );
  }

  function hasAutomaticGiftHeader(init) {
    var headers = init && init.headers;

    if (!headers) {
      return false;
    }

    if (typeof headers.get === 'function') {
      return headers.get('X-Nariyal-Automatic-Gift') === '1';
    }

    return headers['X-Nariyal-Automatic-Gift'] === '1' ||
      headers['x-nariyal-automatic-gift'] === '1';
  }

  function hasFeaturedCollectionHeader(init) {
    var headers = init && init.headers;

    if (!headers) {
      return false;
    }

    if (typeof headers.get === 'function') {
      return headers.get('X-Nariyal-Featured-Collection-Add') === '1';
    }

    return headers['X-Nariyal-Featured-Collection-Add'] === '1' ||
      headers['x-nariyal-featured-collection-add'] === '1';
  }

  /* Block a second, app-originated request that adds only this free-gift
     variant. Product and multi-item bundle requests are not changed. */
  function isStandaloneDuplicateGiftAdd(input, init) {
    if (!isCartAdd(input) || hasAutomaticGiftHeader(init) || !init || !init.body) {
      return false;
    }

    var ids = [];
    var body = init.body;

    if (body instanceof FormData || body instanceof URLSearchParams) {
      if (body.get('id')) {
        ids.push(body.get('id'));
      }

      for (var index = 0; body.has('items[' + index + '][id]'); index++) {
        ids.push(body.get('items[' + index + '][id]'));
      }
    } else if (typeof body === 'string') {
      try {
        var payload = JSON.parse(body);
        var items = Array.isArray(payload.items) ? payload.items : [payload];

        ids = items.map(function (item) {
          return item && item.id;
        }).filter(Boolean);
      } catch (error) {
        var params = new URLSearchParams(body);

        if (params.get('id')) {
          ids.push(params.get('id'));
        }
      }
    }

    return ids.length > 0 && ids.every(function (id) {
      return String(id) === giftVariantIdString;
    });
  }

  /*
   * Some promotion integrations submit the paid product and this same gift in
   * one JSON request. Remove the gift from that mixed payload and let this
   * single guard add/maintain it. Otherwise Shopify merges the app gift with
   * the existing gift and quantity becomes 2.
   */
  function withoutEmbeddedGift(init) {
    if (!init || typeof init.body !== 'string') {
      return init;
    }

    try {
      var payload = JSON.parse(init.body);

      if (!payload || !Array.isArray(payload.items)) {
        return init;
      }

      var paidItems = payload.items.filter(function (item) {
        return item && String(item.id) !== giftVariantIdString;
      });

      if (paidItems.length === payload.items.length || paidItems.length === 0) {
        return init;
      }

      var sanitizedInit = Object.assign({}, init);
      var sanitizedPayload = Object.assign({}, payload, { items: paidItems });
      sanitizedInit.body = JSON.stringify(sanitizedPayload);
      return sanitizedInit;
    } catch (error) {
      return init;
    }
  }

  function notifyTheme(cart, changed) {
    function dispatchCartState() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cart,
          openMiniCart: false
        }
      }));
    }

    dispatchCartState();

    /*
     * Product forms can render the original /cart/add response after this
     * callback. Refresh again after that stale response has completed so the
     * newly-added gift is visible immediately in the drawer.
     */
    if (changed) {
      window.setTimeout(dispatchCartState, 250);
      window.setTimeout(dispatchCartState, 900);
    }

    if (changed && /\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  function updateGiftLines(cart, giftLines, quantity) {
    var updates = {};

    giftLines.forEach(function (line, index) {
      updates[line.key] = index === 0 ? quantity : 0;
    });

    return giftFetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Nariyal-Automatic-Gift': '1'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to update the free gift');
      }

      return response.json();
    });
  }

  function addGift() {
    return giftFetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Nariyal-Automatic-Gift': '1'
      },
      body: JSON.stringify({
        items: [{
          id: giftVariantId,
          quantity: 1,
          properties: {
            '_free-gift': 'Included with your order'
          }
        }]
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to add the free gift');
      }

      return giftFetch(cartUrl('cart.js'), {
        headers: { 'Accept': 'application/json' }
      }).then(function (cartResponse) {
        return cartResponse.json();
      });
    });
  }

  function cleanPublicGiftProperties(cart) {
    var contaminatedLine = cart.items.find(function (item) {
      return (
        String(item.variant_id) !== giftVariantIdString &&
        item.properties &&
        Object.prototype.hasOwnProperty.call(item.properties, 'Free gift')
      );
    });

    if (!contaminatedLine) {
      return Promise.resolve(cart);
    }

    var preservedProperties = {};

    Object.keys(contaminatedLine.properties).forEach(function (key) {
      if (key !== 'Free gift') {
        preservedProperties[key] = contaminatedLine.properties[key];
      }
    });

    return giftFetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: contaminatedLine.key,
        quantity: contaminatedLine.quantity,
        properties: preservedProperties
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to remove the old free-gift label');
        }

        return response.json();
      })
      .then(cleanPublicGiftProperties);
  }

  function performSync() {
    return giftFetch(cartUrl('cart.js'), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(cleanPublicGiftProperties)
      .then(function (cart) {
        var giftLines = cart.items.filter(isComplimentaryGiftLine);
        var regularItems = cart.items.filter(function (item) {
          return !isComplimentaryGiftLine(item) && item.final_line_price > 0;
        });

        if (regularItems.length > 0 && giftLines.length === 0) {
          return addGift().then(function (updatedCart) {
            notifyTheme(updatedCart, true);
            return updatedCart;
          });
        }

        if (regularItems.length === 0 && giftLines.length > 0) {
          return updateGiftLines(cart, giftLines, 0).then(function (updatedCart) {
            notifyTheme(updatedCart, true);
            return updatedCart;
          });
        }

        if (
          regularItems.length > 0 &&
          (giftLines.length > 1 || giftLines[0].quantity !== 1)
        ) {
          return updateGiftLines(cart, giftLines, 1).then(function (updatedCart) {
            /*
             * Keep this correction silent. The promotion listener also
             * consumes the theme cart events; emitting one here makes it apply
             * its gift rule again and changes the quantity straight back to 2.
             * The server cart is now correct, while the UI guard below hides
             * the non-editable gift quantity controls.
             */
            return updatedCart;
          });
        }

        /*
         * The cart is already correct. Do not emit cart:updated/cart:refresh
         * during every stabilization pass, otherwise drawers and the cart
         * page visibly rerender several times after a single add.
         */
        return cart;
      })
      .catch(function (error) {
        console.error('[Nariyal free gift]', error);
      });
  }

  function ensureGiftReady() {
    return performSync()
      .then(function () {
        return giftFetch(cartUrl('cart.js'), {
          headers: { 'Accept': 'application/json' }
        }).then(function (response) { return response.json(); });
      })
      .then(function (cart) {
        var giftLines = cart.items.filter(isComplimentaryGiftLine);
        var regularItems = cart.items.filter(function (item) {
          return !isComplimentaryGiftLine(item) && item.final_line_price > 0;
        });

        if (regularItems.length === 0) {
          throw new Error('No paid product is present in the cart');
        }

        if (giftLines.length === 1 && giftLines[0].quantity === 1) {
          return cart;
        }

        return giftLines.length === 0
          ? addGift()
          : updateGiftLines(cart, giftLines, 1);
      })
      .then(function () {
        return giftFetch(cartUrl('cart.js'), {
          headers: { 'Accept': 'application/json' }
        }).then(function (response) { return response.json(); });
      })
      .then(function (cart) {
        var giftLines = cart.items.filter(isComplimentaryGiftLine);
        var hasRegularItem = cart.items.some(function (item) {
          return !isComplimentaryGiftLine(item) && item.final_line_price > 0;
        });

        if (!hasRegularItem || giftLines.length !== 1 || giftLines[0].quantity !== 1) {
          throw new Error('Free gift verification failed');
        }

        return cart;
      });
  }

  function reportGiftCheckoutError(error) {
    console.error('[Nariyal checkout gift verification]', error);
  }

  function ensureGiftStableForCheckout() {
    return ensureGiftReady()
      .then(function () {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 450);
        });
      })
      .then(ensureGiftReady);
  }

  /*
   * Lip Balm's checkout button may be replaced after page load by the bundle
   * widget. Capture only this variant so direct Buy It Now can never open
   * checkout before the real order gift exists in Shopify's server cart.
   */
  var lipBalmAddBusy = false;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[type="submit"], input[type="submit"]');
    var form = button && (button.form || button.closest('form[action*="/cart/add"]'));
    if (!button || !form || lipBalmAddBusy) return;

    var formData = new FormData(form);
    var idInput = form.querySelector('[name="id"]');
    var variantId = formData.get('id') || (idInput && idInput.value);
    if (String(variantId) !== '55025194631473') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    lipBalmAddBusy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    if (!formData.get('id') && idInput && idInput.value) {
      formData.set('id', idInput.value);
    }
    formData.set('quantity', formData.get('quantity') || '1');

    window.fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add Lip Balm');
        return ensureGiftStableForCheckout();
      })
      .then(function () {
        if (typeof window.__nariyalScheduleNativeCart === 'function') {
          window.__nariyalScheduleNativeCart();
        }
      })
      .catch(reportGiftCheckoutError)
      .finally(function () {
        lipBalmAddBusy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }, true);

  var lipBalmBuyNowBusy = false;
  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '[data-nariyal-buy-now]'
    );
    if (!button || lipBalmBuyNowBusy) return;

    var form = button.form || button.closest('form');
    if (!form) {
      var root = button.closest('product-form, .shopify-section--main-product, .product, [data-product-id]');
      form = root && root.querySelector('form[action*="/cart/add"]');
    }
    if (!form) return;

    var formData = new FormData(form);
    var idInput = form.querySelector('[name="id"]');
    var variantId = formData.get('id') || (idInput && idInput.value);
    if (String(variantId) !== '55025194631473') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    lipBalmBuyNowBusy = true;
    buyNowIntentUntil = Date.now() + 10000;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    if (!formData.get('id') && idInput && idInput.value) {
      formData.set('id', idInput.value);
    }
    formData.set('quantity', formData.get('quantity') || '1');

    var giftVerified = false;

    window.fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add Lip Balm');
        /* The universal cart-add guard has already waited for the automatic
           gift reconciliation before resolving this request. Verify the
           resulting server cart once here; repeating the delayed two-pass
           cycle made Buy It Now slow and could race with checkout opening. */
        return ensureGiftReady();
      })
      .then(function () {
        giftVerified = true;
        // window.location.assign(cartUrl('checkout'));
      })
      .catch(function (error) {
        if (!giftVerified) {
          reportGiftCheckoutError(error);
        } else {
          console.error('[Nariyal Lip Balm checkout]', error);
        }
      })
      .finally(function () {
        lipBalmBuyNowBusy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }, true);

  var nativeBuyNowBusy = false;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-nariyal-buy-now]');
    if (!button || nativeBuyNowBusy) return;

    var form = button.form || button.closest('form');
    if (!form) return;

    var formData = new FormData(form);
    var idInput = form.querySelector('[name="id"]');
    var variantId = formData.get('id') || (idInput && idInput.value);

    /* This product has its own stronger checkout verifier loaded separately. */
    if (String(variantId) === '55026227511601') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    nativeBuyNowBusy = true;
    buyNowIntentUntil = Date.now() + 10000;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    if (!formData.get('id') && idInput && idInput.value) {
      formData.set('id', idInput.value);
    }
    formData.set('quantity', formData.get('quantity') || '1');

    window.fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add Buy It Now product');
        return ensureGiftReady();
      })
      .then(function () {
        // window.location.assign(cartUrl('checkout'));
      })
      .catch(reportGiftCheckoutError)
      .finally(function () {
        nativeBuyNowBusy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }, true);

  function syncGift() {
    if (!syncPromise) {
      var delay = Math.max(0, syncNotBefore - Date.now());

      syncPromise = new Promise(function (resolve) {
        window.setTimeout(resolve, delay);
      })
        .then(performSync)
        .finally(function () {
          syncPromise = null;

          if (Date.now() < syncNotBefore) {
            window.setTimeout(syncGift, syncNotBefore - Date.now());
          }
        });
    }

    return syncPromise;
  }

  /*
   * Promotion/cart apps can finish their own cart write after the product-add
   * response has resolved. A single immediate reconciliation therefore races
   * with that delayed write and briefly (or permanently) leaves gift quantity
   * equal to the number of paid products. Recheck across the app's update
   * window; performSync also refreshes the drawer whenever it corrects state.
   */
  function stabilizeGift() {
    stabilizationTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });

    stabilizationTimers = [0, 300, 900, 1800, 3200].map(function (delay) {
      return window.setTimeout(function () {
        syncNotBefore = Date.now();
        syncGift();
      }, delay);
    });
  }

  /*
   * Universal cart invariant: every customer-facing add must finish with
   * exactly one complimentary gift before its caller renders a cart drawer or
   * redirects to checkout. The second pass catches promotion apps that write
   * once more shortly after Shopify resolves the original add request.
   */
  function settleGiftBeforeContinue() {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, 500);
    })
      .then(performSync)
      .then(function () {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 300);
        });
      })
      .then(performSync);
  }

  window.fetch = function (input, init) {
    if (isStandaloneDuplicateGiftAdd(input, init)) {
      stabilizeGift();

      return giftFetch(cartUrl('cart.js'), {
        headers: { 'Accept': 'application/json' }
      });
    }

    if (isCartAdd(input)) {
      init = withoutEmbeddedGift(init);
    }

    var responsePromise = giftFetch(input, init);
    var isProductAdd = isCartAdd(input);
    var isBuyNowAdd = isProductAdd && Date.now() <= buyNowIntentUntil;
    var opensCartItself = hasFeaturedCollectionHeader(init);

    if (!isCartMutation(input)) {
      return responsePromise;
    }

    return responsePromise.then(function (response) {
      if (!response.ok) {
        return response;
      }

      /*
       * Do not resolve any product add until the final server cart has exactly
       * one gift. This covers collection cards, product forms, quick buy,
      * Add to Bag and Buy It Now/checkout redirects with one rule.
      */
      if (isProductAdd) {
        return settleGiftBeforeContinue().then(function () {
          stabilizeGift();

          if (
            !isBuyNowAdd &&
            !opensCartItself &&
            typeof window.__nariyalScheduleNativeCart === 'function'
          ) {
            window.__nariyalScheduleNativeCart();
          }

          if (isBuyNowAdd) {
            buyNowIntentUntil = 0;
          }

          return response;
        });
      }

      /*
       * Return the original product-add response immediately so the theme can
       * render the purchased item first. The complimentary gift is synced just
       * afterwards; waiting here made the gift appear before the main product.
       */
      // Reconcile before the native cart opens so the free gift can never
      // briefly appear with an incorrect quantity.
      stabilizeGift();

      return response;
    });
  };

  /*
   * Some app widgets mutate the cart through XMLHttpRequest
   * instead of window.fetch. Observe that path too so a gift quantity copied
   * from the number of purchased products is always corrected back to one.
   */
  if (window.XMLHttpRequest && !window.__nariyalGiftXhrGuard) {
    window.__nariyalGiftXhrGuard = true;

    var nativeXhrOpen = window.XMLHttpRequest.prototype.open;
    var nativeXhrSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__nariyalCartMutation = isCartMutation(url);
      this.__nariyalCartAddUrl = isCartAdd(url) ? url : null;
      return nativeXhrOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function (body) {
      if (this.__nariyalCartAddUrl) {
        body = withoutEmbeddedGift({ body: body }).body;
      }

      /* Some cart apps use XHR instead of fetch to add the gift again after a
         product add. Match the fetch guard above and turn that standalone
         duplicate-gift request into a harmless cart read. */
      if (
        this.__nariyalCartAddUrl &&
        isStandaloneDuplicateGiftAdd(this.__nariyalCartAddUrl, { body: body })
      ) {
        stabilizeGift();

        nativeXhrOpen.call(this, 'GET', cartUrl('cart.js'), true);
        return nativeXhrSend.call(this);
      }

      if (this.__nariyalCartMutation) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 400) {
            stabilizeGift();
          }
        }, { once: true });
      }

      return nativeXhrSend.apply(this, arguments);
    };
  }

  document.addEventListener('DOMContentLoaded', syncGift);

  document.documentElement.addEventListener('cart:updated', function () {
    syncGift();
  });

  window.addEventListener('pageshow', function () {
    syncGift();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      syncGift();
    }
  });
})();

/*
 * Some cart drawers render outside the theme's Liquid line-item markup.
 * Hide only the quantity control belonging to the exact "Free Gift" row.
 * This does not touch checkout buttons, links or normal product quantities.
 */
(function () {
  if (window.__nariyalGiftQuantityUi) {
    return;
  }

  window.__nariyalGiftQuantityUi = true;

  function hideGiftQuantityControls() {
    document.querySelectorAll('span, p, div').forEach(function (label) {
      if (label.children.length > 0 || label.textContent.trim() !== 'Free Gift') {
        return;
      }

      var row = label;

      for (var depth = 0; row && depth < 6; depth++, row = row.parentElement) {
        var buttons = row.querySelectorAll('button, [role="button"]');
        var hasFreeLabel = /\bFREE!?\b/i.test(row.textContent);

        if (!hasFreeLabel || buttons.length < 2) {
          continue;
        }

        var quantityButtons = Array.prototype.filter.call(buttons, function (button) {
          var text = button.textContent.trim();
          var aria = button.getAttribute('aria-label') || '';
          return (
            text === '+' ||
            text === '-' ||
            text === '−' ||
            /increase|decrease|quantity/i.test(aria)
          );
        });

        if (quantityButtons.length >= 2) {
          var quantityControl = quantityButtons[0].parentElement;

          if (
            quantityControl &&
            quantityButtons.every(function (button) {
              return button.parentElement === quantityControl;
            })
          ) {
            quantityControl.style.setProperty('display', 'none', 'important');
          } else {
            quantityButtons.forEach(function (button) {
              button.style.setProperty('display', 'none', 'important');
            });
          }

          break;
        }
      }
    });
  }

  var observer = new MutationObserver(hideGiftQuantityControls);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', hideGiftQuantityControls);
  document.documentElement.addEventListener('cart:refresh', hideGiftQuantityControls);
})();
/* Keep the Soap Pack BOGO cart at one charged line and render one free pack. */
(function () {
  var SOAP_VARIANT = '55264654229809';
  var VCO_VARIANT = '55026179309873';
  var normalizing = false;
  var checkoutBusy = false;

  function cartUrl(path) {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    return root + path;
  }

  function requestJson(method, path, body) {
    return fetch(cartUrl(path), {
      method: method,
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Soap cart normalization failed');
      return response.json();
    });
  }

  function ensureBogoFreeItems() {
    return requestJson('GET', 'cart.js').then(function (cart) {
      var paidSoapQuantity = 0;
      var freeSoapQuantity = 0;
      var paidVcoQuantity = 0;
      var freeVcoQuantity = 0;

      cart.items.forEach(function (item) {
        var variantId = String(item.variant_id);

        if (variantId === SOAP_VARIANT) {
          if (item.final_line_price === 0) {
            freeSoapQuantity += item.quantity;
          } else {
            paidSoapQuantity += item.quantity;
          }
        }

        if (variantId !== VCO_VARIANT) return;

        if (item.properties && item.properties._vco_bogo_role === 'free') {
          freeVcoQuantity += item.quantity;
        } else {
          paidVcoQuantity += item.quantity;
        }
      });

      var missingSoapQuantity = Math.max(0, paidSoapQuantity - freeSoapQuantity);
      var missingVcoQuantity = Math.max(0, paidVcoQuantity - freeVcoQuantity);
      var missingItems = [];

      if (missingSoapQuantity) {
        missingItems.push({
          id: Number(SOAP_VARIANT),
          quantity: missingSoapQuantity,
          properties: { _soap_bogo_role: 'free' }
        });
      }

      if (missingVcoQuantity) {
        missingItems.push({
          id: Number(VCO_VARIANT),
          quantity: missingVcoQuantity,
          properties: { _vco_bogo_role: 'free' }
        });
      }

      if (!missingItems.length) return cart;

      return requestJson('POST', 'cart/add.js', {
        items: missingItems
      });
    });
  }

  function verifyBogoFreeItems(attempt) {
    attempt = attempt || 0;

    return ensureBogoFreeItems().then(function () {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 250);
      });
    }).then(function () {
      return requestJson('GET', 'cart.js');
    }).then(function (cart) {
      var paidVcoQuantity = 0;
      var freeVcoQuantity = 0;

      cart.items.forEach(function (item) {
        if (String(item.variant_id) !== VCO_VARIANT) return;

        if (item.properties && item.properties._vco_bogo_role === 'free') {
          freeVcoQuantity += item.quantity;
        } else {
          paidVcoQuantity += item.quantity;
        }
      });

      if (!paidVcoQuantity || paidVcoQuantity === freeVcoQuantity) return cart;
      if (attempt >= 1) throw new Error('VCO BOGO pair verification failed');

      return verifyBogoFreeItems(attempt + 1);
    });
  }

  function renderFreeSoapRow() {
    var selector = '.line-item[data-variant-id="' + SOAP_VARIANT + '"]';
    document.querySelectorAll(selector + '.line-item--soap-unit-clone').forEach(function (row) {
      row.remove();
    });

    function prepareFreeUnit(row) {
      row.classList.remove('line-item--soap-offer-paid');
      row.classList.add('line-item--soap-offer-free');
      row.dataset.lineQuantity = '1';
      row.dataset.soapFreeRendered = 'true';
      row.querySelectorAll('.line-item__quantity, .quantity-selector, .line-item__remove-button, .line-item__discount-list, .discount-badge, .line-item__free-quantity').forEach(function (node) {
        node.remove();
      });
      row.querySelectorAll('.price-list').forEach(function (prices) {
        prices.innerHTML = '<span class="price price--highlight">Free!</span><span class="price price--compare">Rs. 199</span>';
      });
      return row;
    }

    var actualFreeRows = Array.prototype.slice.call(document.querySelectorAll(selector + '.line-item--soap-offer-free:not(.line-item--soap-unit-clone)'));
    if (actualFreeRows.length) {
      actualFreeRows.forEach(function (freeRow) {
        var freeQuantity = Math.max(1, Number(freeRow.dataset.soapOriginalQuantity || freeRow.dataset.lineQuantity) || 1);
        freeRow.dataset.soapOriginalQuantity = String(freeQuantity);
        prepareFreeUnit(freeRow);
        var insertionPoint = freeRow;

        for (var unit = 1; unit < freeQuantity; unit += 1) {
          var unitRow = prepareFreeUnit(freeRow.cloneNode(true));
          unitRow.classList.add('line-item--soap-unit-clone');
          insertionPoint.parentNode.insertBefore(unitRow, insertionPoint.nextSibling);
          insertionPoint = unitRow;
        }
      });
      return;
    }

    var sourcePaidRow = document.querySelector(selector + ':not(.line-item--soap-offer-free)');
    if (!sourcePaidRow || !sourcePaidRow.parentNode) return;
    sourcePaidRow.dataset.soapFreeRendered = 'true';
    sourcePaidRow.classList.add('line-item--soap-offer-paid');
    var sourceQuantityInput = sourcePaidRow.querySelector('.quantity-selector__input');
    var sourceQuantity = Math.max(1, Number(sourceQuantityInput ? sourceQuantityInput.value : sourcePaidRow.dataset.lineQuantity) || 1);
    var sourceInsertionPoint = sourcePaidRow;

    for (var sourceUnit = 0; sourceUnit < sourceQuantity; sourceUnit += 1) {
      var syntheticUnitRow = prepareFreeUnit(sourcePaidRow.cloneNode(true));
      syntheticUnitRow.classList.add('line-item--soap-unit-clone');
      sourceInsertionPoint.parentNode.insertBefore(syntheticUnitRow, sourceInsertionPoint.nextSibling);
      sourceInsertionPoint = syntheticUnitRow;
    }
    return;

    document.querySelectorAll(selector).forEach(function (paidRow) {
      if (paidRow.classList.contains('line-item--soap-offer-free')) return;
      if (paidRow.dataset.soapFreeRendered === 'true') return;
      if (paidRow.parentNode.querySelector(selector + '.line-item--soap-offer-free')) return;

      paidRow.dataset.soapFreeRendered = 'true';
      paidRow.classList.add('line-item--soap-offer-paid');
      var paidQuantityInput = paidRow.querySelector('.quantity-selector__input');
      var displayedFreeQuantity = paidQuantityInput ? Number(paidQuantityInput.value) || 1 : 1;
      var freeRow = paidRow.cloneNode(true);
      freeRow.classList.remove('line-item--soap-offer-paid');
      freeRow.classList.add('line-item--soap-offer-free');
      freeRow.dataset.soapFreeRendered = 'true';
      freeRow.querySelectorAll('.line-item__quantity, .quantity-selector, .line-item__remove-button, .line-item__discount-list, .discount-badge').forEach(function (node) {
        node.remove();
      });
      freeRow.querySelectorAll('.price-list').forEach(function (prices) {
        prices.innerHTML = '<span class="price price--highlight">Free!</span><span class="price price--compare">Rs. 199</span>';
      });
      var freeInfo = freeRow.querySelector('.line-item__info');
      if (freeInfo && !freeInfo.querySelector('.line-item__free-quantity')) {
        var freeQuantity = document.createElement('span');
        freeQuantity.className = 'line-item__free-quantity';
        freeQuantity.textContent = 'Free × ' + displayedFreeQuantity;
        freeInfo.appendChild(freeQuantity);
      }
      paidRow.parentNode.insertBefore(freeRow, paidRow.nextSibling);
    });
  }

  function normalizeSoapCart() {
    if (normalizing || window.__nariyalSoapCheckoutPending || window.__nariyalSoapRemovalPending) return;
    normalizing = true;

    requestJson('GET', 'cart.js').then(function (cart) {
      var paidLines = [];
      var freeLines = [];

      cart.items.forEach(function (item) {
        if (String(item.variant_id) !== SOAP_VARIANT) return;

        if (item.final_line_price === 0) {
          freeLines.push(item);
        } else {
          paidLines.push(item);
        }
      });

      if (!paidLines.length) return cart;

      var paidQuantity = paidLines.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
      var freeQuantity = freeLines.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
      var needsConsolidation = paidLines.length > 1 || freeLines.length > 1 || freeQuantity !== paidQuantity;

      if (!needsConsolidation) {
        renderFreeSoapRow();
        return cart;
      }

      var updates = {};
      paidLines.forEach(function (item, index) {
        updates[item.key] = index === 0 ? paidQuantity : 0;
      });
      freeLines.forEach(function (item, index) {
        updates[item.key] = index === 0 ? paidQuantity : 0;
      });

      return requestJson('POST', 'cart/update.js', { updates: updates }).then(function () {
        if (freeLines.length) return;

        return requestJson('POST', 'cart/add.js', {
          items: [{
            id: Number(SOAP_VARIANT),
            quantity: paidQuantity,
            properties: { _soap_bogo_role: 'free' }
          }]
        });
      }).then(function () {
        window.location.reload();
      });
    }).catch(function (error) {
      console.error('[Nariyal Soap BOGO cart]', error);
    }).finally(function () {
      normalizing = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeSoapCart, { once: true });
  } else {
    normalizeSoapCart();
  }
  document.documentElement.addEventListener('cart:refresh', function () {
    window.setTimeout(normalizeSoapCart, 100);
  });

  document.addEventListener('click', function (event) {
    var checkoutLink = event.target.closest(
      'a.checkout-button[href*="checkout"], .cart__checkout-button, #mini-cart .checkout-button'
    );
    if (!checkoutLink || checkoutBusy) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    checkoutBusy = true;
    window.__nariyalSoapCheckoutPending = true;
    checkoutLink.setAttribute('aria-busy', 'true');

    verifyBogoFreeItems()
      .then(function () { window.location.assign(cartUrl('checkout')); })
      .catch(function (error) {
        console.error('[Nariyal BOGO checkout]', error);
        checkoutBusy = false;
        window.__nariyalSoapCheckoutPending = false;
        checkoutLink.removeAttribute('aria-busy');
        window.alert('Free offer product add nahi ho paya. Please ek baar phir try karein.');
      });
  }, true);

})();
